<template>
  <div class="process-table-container">
    <table v-if="inData.list" class="process-table">
      <thead>
        <tr>
          <th class="col-index">序号</th>
          <th class="col-measure">措施</th>
          <th class="col-date">开始时间</th>
          <th class="col-date">预计完成</th>
          <th class="col-date">实际完成</th>
          <th class="col-status">状态</th>
          <th v-if="groupMp != '变更经验教训' && groupMp != '实施纠正措施'" class="col-content">内容</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(to, s) in inData.list[0].todos">
          <template v-for="(form, i) in to.list">
            <tr :class="{ 'row-even': idxArry[form.title + s + i] % 2 == 0, 'row-odd': idxArry[form.title + s + i] % 2 != 0 }">
              <td class="cell-index">{{ idxArry[form.title + s + i] }}</td>
              <td class="cell-measure">
                <span class="measure-text">{{ to.todo.title }}</span>
                <span v-if="form.title != '5Why' && form.title != '鱼骨图' && groupMp != '变更经验教训' && groupMp != '实施纠正措施'" class="measure-arrow">→</span>
                <span v-if="groupMp != '变更经验教训' && groupMp != '实施纠正措施'" class="measure-sub">{{ form.title }}</span>
              </td>
              <td class="cell-date">
                <span class="date-text">{{ formatDate(to.todo.createdTime)}}</span>
              </td>
              <td class="cell-date">
                <span class="date-text">{{ formatDate(to.todo.dueDate)}}</span>
              </td>
              <td class="cell-date">
                <span class="date-text">{{ formatDate(to.todo.actualDate)}}</span>
              </td>
              <td class="cell-status">
                <span class="status-badge" :class="{ 'status-completed': to.todo.completed, 'status-pending': !to.todo.completed }">
                  {{ to.todo.completed ? "已完成" : "未完成" }}
                </span>
              </td>
              <td v-if="groupMp != '变更经验教训' && groupMp != '实施纠正措施'" class="cell-content">
                <div class="content-text" v-html="form.formValue"></div>
              </td>
            </tr>
          </template>
        </template>
        <template v-if="index < 5">
          <tr class="row-empty" v-for="(team, i) in (5 - index)" :key="'empty-' + i">
            <td colspan="7"></td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import API from "@/utils/api";
import { Loading } from "element-ui";
import router from "../../../router";
import format from "date-fns/format";
export default {
  name: "process-board",
  props: {
    initData: {
      type: Object,
      default: function () {
        return {};
      },
    },
    groupTitle: {
      type: String,
      default: function () {
        return "实施纠正措施";
      },
    },
  },
  watch: {
    initData: {
      handler: function (val, oldVal) {
        var data = val;
        this.inData = val;
        var arry = {};
        var idx = 0;
        for (var i = 0; i < data.list[0].todos.length; i++) {
          var to = data.list[0].todos[i];
          for (var j = 0; j < to.list.length; j++) {
            idx += 1;
            var key = to['list'][j]['title'] + i + j;
            arry[key] = idx;
          }
        }
        this.idxArry = arry;
        this.index = idx;
      },
      deep: true,
    },
    groupTitle: {
      immediate: true,
      handler: function (val, oldVal) {
        if (!val) {
          val = "实施纠正措施";
        }
        this.groupMp = val;
      },
      deep: true,
    },
  },
  data() {
    return {
      inData: {},
      index: 0,
      idxArry: {},
      groupMp: null
    };
  },
  mounted() {

  },
  destroyed() {

  },
  filters: {},
  methods: {
    formatDate(time) {
      if (time && time != '0') {
        var date = new Date(Number(time));
        return format(date, "yyyy-MM-dd");
      }
      return "";
    },
    next(i) {
      var idx = this.index;
      this.index += 1;
      return idx;
    }
  }
};
</script>

<style scoped src='./board.css'></style>



// WEBPACK FOOTER //
// src/pages/fr/process/board.vue